import { useEffect, useState } from "react"
import { GridLayout } from "./layout"
import { PayCard } from "../molecule/payCard"
import { CompleteOrderModal } from "./customModals"
import { getAPI } from "../api/api"

export const PayOrderOptions = ({}) => {


    const [payOptions, setPayOptions] = useState([])
    
    useEffect(() => {
        loadPackages()
    }  
    ,[])
    const loadPackages = async () => {
        const QUERY = `api/orders/packages`
        const load = await getAPI(QUERY)
        setPayOptions(load.data.reverse())
    }
    const [visibleModal, setVisibleModal] = useState(false)
    const handleSelect = (index ) => {
        const copyOptions = [...payOptions]
        copyOptions.filter(option => option.selected = false)
        copyOptions[index].selected = true
        setPayOptions(copyOptions)
        handleOrderModal()
    }  
    const handleOrderModal = () => {
        setVisibleModal(!visibleModal)
    } 


    return (
        <GridLayout 
            className="paycard-grid"
            style={{margin:"1rem"}}
            columnsTemplate={"repeat(3, 1fr)"}

        >
            {(payOptions).map((option,index) => {
                return(
                    <PayCard
                        onClick={() => handleSelect(index)}
                        payData={option}
                    />
                )
            })}
            <CompleteOrderModal
                orderPackage={payOptions.filter(order => order.selected)[0]}
                dismiss={handleOrderModal}
                visible={visibleModal}
            />
        </GridLayout>
    )
}